import styled from '@emotion/styled';
import { rem } from '@utils';

const ExpandWrapper = styled.div`
  background: var(--expand-button-line-color);
  display: block;
  position: absolute;
  inset: 0 auto auto 100%;
  height: 100%;
  width: 1px;
  transition: 100ms ease;
  z-index: 1;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.main};
  }
`;

const ExpandButton = styled.span<{
  isActive: boolean;
  yPosition?: number;
}>(
  ({ isActive, yPosition, theme }) => `
  background: var(--expand-button-background-color);
  color: var(--expand-button-color);
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--expand-button-box-shadow-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: ${rem(2)};
  position: absolute;
  right: -12px;
  top: ${typeof yPosition === 'number' ? `${yPosition}px` : '50%'};
  width: ${rem(24)};
  height: ${rem(24)};
  transition: 100ms ease;
  transform: 
    rotateZ(${isActive ? '-180deg' : '0deg'}) 
    translateY(${typeof yPosition === 'number' ? 0 : '-50%'});

  @media (max-width: 430px) {
    width: ${rem(28)};
    height: ${rem(28)};
    right: -13px;
  }

  ${ExpandWrapper}:hover & {
    box-shadow: inset 0 0 0 1px ${theme.palette.primary.main};
  }

  &:focus-visible {
    outline: 2px solid ${theme.palette.primary.dark};
    outline-offset: 1px;
  }

  .tooltip-wrapper {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`
);

export default {
  ExpandWrapper,
  ExpandButton
};
